import { $api } from '@service/RequestService';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { NumericArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { WidgetBodyModel } from '../models';

export function useNumberWidget({ body, id }: { body: WidgetBodyModel; id: number }) {
  const [query] = useQueryParams({
    startDate: StringParam,
    finishDate: StringParam,
    responsibleByIds: NumericArrayParam
  });

  const parseQuery = queryString.stringify(query);

  const initial = {
    count: 0,
    amount: 0,
    countDate: 0,
    amountDate: 0
  };

  const { data = initial, ...arg } = useQuery<{
    count?: number;
    amount?: number;
    countDate?: number;
    amountDate?: number;
  }>(
    ['dashboard-v2-number', id, parseQuery],
    async () => {
      const { data } = await $api.post(`/v1/dashboard/widget/number${parseQuery ? `?${parseQuery}` : ''}`, body);

      return { ...data?.data };
    },
    {
      enabled: !!body?.dashboardId
    }
  );

  return { ...data, ...arg };
}
